<div class="container py-4 text-primary" *transloco="let t">
  <form [formGroup]="registerForm" [class.was-validated]="registerForm.touched" (ngSubmit)="register()">

    <div class="alert alert-secondary mt-2" role="alert">
      <details>
        <summary>
          <lucide-icon [img]="icons.mailbox"></lucide-icon>
          J'utilise mon adresse email personnelle ou celle de mon organisation ? Clique pour en savoir plus.
        </summary>
        <p class="mt-2">
          C'est égal, mais voici quelques conseils:
        </p>
        <ul>
          <li>Tu n'es pas membre d'une organisation → utilise ton adresse personnelle.</li>
          <li>Tu as accès à une adresse email de ton organisation (ex.: info&#64;monclub.ch) → c'est parfait. </li>
          <li>Ton organisation n'a pas d'adresse email → ton adresse personnelle va aussi très bien.</li>
        </ul>
        <p>
          Notes:
        </p>
        <ul>
          <li>Un seul compte peut gérer plusieurs organisations</li>
          <li>Une organisation ne peut actuellement pas être gérée par plusieurs comptes, mais c'est prévu, merci pour ta patience!</li>
        </ul>

      </details>
    </div>

    <div class="row">
      <div class="col">
        <app-email-field
          [formControl]="registerForm.controls.email"
          [maxLength]="255"
          [label]="t('auth.register.Email')"
          (keyup)="onKeyUp()">
        </app-email-field>

        @if (isUserConflict()) {
          <div class="invalid-feedback d-block" *transloco="let t">
            {{ t('form.error.UserConflict') }}
            <a class="btn btn-link" [routerLink]="[routes.login]">{{ t('auth.register.Login') }}</a>
          </div>
        }
      </div>
    </div>

    <div class="alert alert-light mt-3" role="alert">
      <lucide-icon [img]="icons.idea"></lucide-icon>
      Nous utilisons les informations ci-dessous pour personnaliser nos messages.
    </div>

    <div class="row">
      <div class="col">
        <app-choice-select-field
          [formControl]="registerForm.controls.title"
          [choices]="titleChoices"
          [label]="t('auth.register.Title')"
          [optional]="true">
        </app-choice-select-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <app-string-field
          [formControl]="registerForm.controls.name"
          [maxLength]="255"
          [label]="t('auth.register.Name')"
          [description]="'Nom de famille si tu utilises une adresse email personnelle, sinon: nom de l\'organisation.'"
          [optional]="true">
        </app-string-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <app-string-field
          [formControl]="registerForm.controls.firstName"
          [maxLength]="255"
          [optional]="true"
          [label]="t('auth.register.FirstName')">
        </app-string-field>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <app-toggle-switch-field
          [formControl]="registerForm.controls.newsletter"
          [description]="t('auth.register.Newsletter.desc')"
          [valueLabel]="t('auth.register.Newsletter.label')"
          [optional]="true">
        </app-toggle-switch-field>
      </div>
    </div>

    <app-altcha formControlName="captcha"/>

    <div class="row mt-5">
      <div class="col">
        <p class="text-end text-dark">
          {{ t('activity.publish.guest.acceptPublishConds') }}
          <a [routerLink]="routes.terms" class="link-dark link-offset-2" target="_blank">{{ t('activity.publish.guest.termsLink') }}</a>
        </p>
      </div>
    </div>

    <div class="row my-2">
      <div class="col">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end">
          <a class="btn btn-link me-1" [routerLink]="routes.login">
            {{ t('auth.register.Login') }}
          </a>
          <button
            type="submit"
            [disabled]="!registerForm.valid"
            class="btn btn-primary">
            {{ t('auth.register.Register') }}
            <lucide-icon [img]="icons.register"></lucide-icon>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<dialog class="p-4" #userRegisteredDialog>
  <p>
    Un email a été envoyé à {{ registerForm.controls.email.value }}. Vérifie ta boîte email pour valider ton compte et continuer.
  </p>
  <div class="d-grid gap-2 d-md-block mt-3 text-end">
    <button type="button" class="btn btn-primary mx-2" (click)="closeUserRegisteredDialog()">Ok</button>
  </div>
</dialog>
